// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__qHwmB","label":"Labeled_label__3U3GD","divider":"Labeled_divider__hP3Dm"};